import React, { useMemo } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { typography } from '../constants/typography';
import { useAppColors } from '../context/PreferencesContext';

type Props = {
  name: string;
  size?: number;
};

function initialsFromName(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

export function ProfileAvatar({ name, size = 48 }: Props) {
  const palette = useAppColors();
  const initials = useMemo(() => initialsFromName(name), [name]);
  const fontSize = size * 0.36;

  return (
    <View
      accessibilityLabel={`Profile photo for ${name}`}
      style={[
        styles.avatar,
        {
          width: size,
          height: size,
          borderRadius: size / 2,
          backgroundColor: palette.primary,
        },
      ]}
    >
      <Text style={[styles.initials, { color: palette.onPrimary, fontSize }]}>
        {initials}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  avatar: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  initials: {
    ...typography.sectionTitle,
    fontWeight: '700',
  },
});
